import { Address, StateUtils, USER_ADDRESSES } from '@spartacus/core'

export const LOAD_ALL_USER_ADDRESSES = '[User] Load All User Addresses'
export const LOAD_ALL_USER_ADDRESSES_FAIL = '[User] Load All User Addresses Fail'
export const LOAD_ALL_USER_ADDRESSES_SUCCESS = '[User] Load All User Addresses Success'

export class LoadAllUserAddresses extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_ALL_USER_ADDRESSES
  constructor (public payload: string) {
    super(USER_ADDRESSES)
  }
}

export class LoadAllUserAddressesFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_ALL_USER_ADDRESSES_FAIL
  constructor (public payload: any) {
    super(USER_ADDRESSES, payload)
  }
}

export class LoadAllUserAddressesSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_ALL_USER_ADDRESSES_SUCCESS
  constructor (public payload: Address[]) {
    super(USER_ADDRESSES)
  }
}
